<template>
    <div class="ssqOrdlt">
        <div class="tit">
            <span v-if="lotteryType == 0">
                <img src="@/assets/common/titLogo.png"
                     alt="" />
                双色球走势图工具</span>
            <span v-if="lotteryType == 1">
                <img src="@/assets/common/titLogo.png"
                     alt="" />
                大乐透走势图工具</span>
        </div>

        <div class="cont1"
             v-if="lotteryType == 0">
            <div>走势图表</div>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/">
                <div>历史开奖号码</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/haoma/">
                <div>号码走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/luzhu/">
                <div>路珠分析</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/dingwei/">
                <div>定位走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/sanqu/">
                <div>红球三分区走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/daxiao/">
                <div>红球大小走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/danshuang/">
                <div>红球单双走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/zhihe/">
                <div>红球质合走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/hezhi/">
                <div>红球和值走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/kuadu/">
                <div>红球首尾走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/shuangseqiu/wuxing/">
                <div>五行走势图</div>
            </a>
            <div>选号工具</div>
            <a target="_blank"
               href="https://www.3533.com/shuangseqiu/">
                <div>在线缩水</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/shuangseqiu/jixuan/">
                <div>在线机选</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/shuangseqiu/ac/">
                <div>AC值计算器</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/shuangseqiu/dantuo/">
                <div>胆施计算器</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/shuangseqiu/fushi/">
                <div>复式计算器</div>
            </a>
        </div>
        <div class="cont1"
             v-if="lotteryType == 1">
            <div>走势图表</div>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/">
                <div>历史开奖号码</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/haoma/#1,1,0">
                <div>号码走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/luzhu/">
                <div>路珠分析</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/dingwei/#1,0,0,0,0,0,0,1,1,0">
                <div>定位走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/sanqu/#1,0">
                <div>前区三分区走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/daxiao/">
                <div>前区大小走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/danshuang/">
                <div>前区单双走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/zhihe/">
                <div>前区质合走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/hezhi/">
                <div>前区和值走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/kuadu/">
                <div>前区首尾走势图</div>
            </a>
            <a target="_blank"
               href="https://caipiao.ip138.com/daletou/wuxing/">
                <div>五行走势图</div>
            </a>
            <div>选号工具</div>
            <a target="_blank"
               href="https://www.3533.com/daletou/">
                <div>在线缩水</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/daletou/jixuan/">
                <div>在线机选</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/daletou/ac/">
                <div>AC值计算器</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/daletou/dantuo/">
                <div>胆拖计算器</div>
            </a>
            <a target="_blank"
               href="https://www.3533.com/daletou/fushi/">
                <div>复式计算器</div>
            </a>
        </div>

        <!-- <div class="cont" v-if="lotteryType == 1">
            <div>前区号码: xxxxx</div>
            <div>后区号码: xxxxx</div>
            <div>前区奇偶比: {{db.parity}}</div>
            <div>前区和值:  {{db.redSum}}</div>
            <div>与上期同号2个: {{db.duplicateNumbers}}</div>
            <div>没有连号: xxxxx</div>
            <div>1对同尾: {{db.tailNumber}}</div>
            <div>极距: {{db.range}}</div>
        </div> -->

    </div>
    <!-- <div class="ssqOrdlt">
        <div class="tit">
			<span v-if="lotteryType == 0">双色球红球特征</span>
			<span v-if="lotteryType == 1">大乐透前后区特征</span>
		</div>
        <div class="btn" v-if="lotteryType == 0">双色球红球特征</div>
        <div class="btn" v-if="lotteryType == 1">开奖号码特征</div>
        <div class="link">第{{db.cycle}}期开奖信息</div>
        <div class="cont" v-if="lotteryType == 0">
            <div>红球: {{db.red}}</div>
            <div>篮球: {{db.blue}}</div>
            <div>奇偶比: {{db.parity}}</div>
            <div>红球和值: {{db.redSum}}</div>
            <div>与上期没有同号:{{db.duplicateNumbers}}</div>
            <div>三区比: {{db.threeZoneRatio}}</div>
            <div>AC值:{{db.ac}}</div>
            <div>极距:{{db.range}}</div>
        </div>
		<div class="cont" v-if="lotteryType == 1">
            <div>前区号码: xxxxx</div>
            <div>后区号码: xxxxx</div>
            <div>前区奇偶比: {{db.parity}}</div>
            <div>前区和值:  {{db.redSum}}</div>
            <div>与上期同号2个: {{db.duplicateNumbers}}</div>
            <div>没有连号: xxxxx</div>
            <div>1对同尾: {{db.tailNumber}}</div>
            <div>极距: {{db.range}}</div>
        </div>
    </div> -->
</template>

<script>
import { queryDictionary } from '@/api/common'
import { queryColorfulSeedByType } from '@/api/home'
export default {
    props: ['lotteryType'],
    data () {
        return {
            db: {},
        }
    },
    mounted () {
        // this.get_feature()
    },
    methods: {
        get_feature () {
            queryColorfulSeedByType(this.lotteryType).then(res => this.db = res.data)
        },
    }
};
</script>

<style lang="scss" scoped>
@import '@/assets/commonStyle.scss';
.ssqOrdlt {
    div {
        white-space: nowrap;
    }
    .tit {
        font-weight: bold;
        padding: 10px;
        padding-top: 0;
        display: flex;
        align-items: center;
        img {
            width: 20px;
            margin-right: 10px;
            vertical-align: top;
        }
    }
    .btn {
        background-color: #f2f2f2;
        padding: 15px;
        text-align: center;
    }
    .link {
        color: #b0d1ff;
        text-align: center;
        font-weight: bold;
        padding: 10px;
    }
    .cont {
        border-top: 1px solid rgba(0, 0, 0, 0.07);
        div {
            padding: 15.8px 8.2px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);
        }
    }
    .cont1 {
        text-align: center;
        border: 1px solid #8fb3da;
        > div {
            font-weight: bold;
            padding: 3.4px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);
            background-color: $theme_color;
            color: #fff;
        }
        > a {
            color: #000;
            text-decoration: none;
            display: block;
            border-bottom: 1px solid rgba(0, 0, 0, 0.07);
            font-size: 13px;
            &:last-child {
                border: 0;
            }
            &:hover {
                // background-color: #4095e5;
                // color: #fff;
                cursor: pointer;
            }

            > div {
				padding: 5.4px 0;
                position: relative;

                &:hover {
					color: #fff;
					font-size: 16px;
                    // transform: scale(1.5);
                    font-weight: bold;
                    // text-decoration: underline;
                    &::after {
                        width: 100%;
                        left: 0%;
                    }
                }
                &:not(:hover) {
                    // transform: scale(1);
                    font-weight: inherit;

                    &::after {
                        width: 0%;
                        left: 50%;
                    }
                }

                &::after {
                    content: '';
                    display: block;
                    border-bottom: 30px solid #3072cd;
                    width: 0%;
                    position: absolute;
					z-index: -1;
                    left: 50%;
					top:0%;
					bottom: 0px;
                    transition: width 0.5s linear, left 0.5s linear;
                }
            }
        }
    }
}
</style>